import { render, staticRenderFns } from "./HomeContactIcons.vue?vue&type=template&id=756fa50f&"
var script = {}
import style0 from "./HomeContactIcons.vue?vue&type=style&index=0&id=756fa50f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports